import {ref} from 'vue';

export default {
    install: (app, options) => {
        const userCompanies = ref([]);
        const userRoles = ref([]);
        const userPlans = ref([]);
        const userFrs = ref([]);
        const userStatuses = ref([]);

        const loadUsersParameters = () => {
            // if (userSubscriptionStatuses.value.length === 0) {
                window.lazy_axios.get(`/users/parameters`)
                    .then((response) => {
                        if (response.data.companies) {
                            userCompanies.value = response.data.companies;
                        }
                        if (response.data.roles) {
                            userRoles.value = response.data.roles;
                        }
                        if (response.data.plans) {
                            userPlans.value = response.data.plans;
                        }
                        if (response.data.frs) {
                            userFrs.value = response.data.frs;
                        }
                        if (response.data.statuses) {
                            userStatuses.value = response.data.statuses;
                        }
                    });
            // }
        };

        app.provide('userCompanies', userCompanies);
        app.provide('userRoles', userRoles);
        app.provide('userPlans', userPlans);
        app.provide('userFrs', userFrs);
        app.provide('userStatuses', userStatuses);
        app.provide('loadUsersParameters', loadUsersParameters);
    },
}
